import Model from '@/lib/data/Model';

const fixedDecimals = function (v) {
    return Number.isNaN(v) ? 0 : parseFloat(parseFloat(v).toFixed(1));
};

class VisitFormScore extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'visit_id',
        'form_data_id',
        'form_name',
        { name: 'risk_weight', getter: fixedDecimals },
        { name: 'protection_weight', getter: fixedDecimals },
        { name: 'risk_score', getter: fixedDecimals },
        { name: 'protection_score', getter: fixedDecimals },
        { name: 'weighted_risk_score', getter: fixedDecimals },
        { name: 'weighted_protection_score', getter: fixedDecimals },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/risk/result',
            params: ['visit_id', 'language_code'],
        },
    ];
}

export default VisitFormScore;
